// src/components/Auth/Auth.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ResetPassword from './ResetPassword';

const Auth = () => {
  // Possible views: signIn, signUp, resetPassword
  const [view, setView] = useState('signIn');
  const { loading, user } = useAuth();
  const navigate = useNavigate();
  
  // Redirect if user is already logged in
  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{
      maxWidth: '400px',
      margin: '0 auto',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1>
          <span style={{ color: "#2980B9" }}>cis</span>
          <span style={{ color: "#CE93D8" }}>fuss</span>
        </h1>
      </div>

      {view === 'signIn' && (
        <>
          <SignIn />
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <p>Don't have an account? 
              <button 
                onClick={() => setView('signUp')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  padding: '0 5px',
                  textDecoration: 'underline',
                }}
              >
                Sign Up
              </button>
            </p>
            <p>
              <button 
                onClick={() => setView('resetPassword')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                Forgot Password?
              </button>
            </p>
          </div>
        </>
      )}

      {view === 'signUp' && (
        <>
          <SignUp />
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <p>Already have an account? 
              <button 
                onClick={() => setView('signIn')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  padding: '0 5px',
                  textDecoration: 'underline',
                }}
              >
                Sign In
              </button>
            </p>
          </div>
        </>
      )}

      {view === 'resetPassword' && (
        <>
          <ResetPassword />
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <p>
              <button 
                onClick={() => setView('signIn')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                Back to Sign In
              </button>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default Auth;